<template>
  <div>
    <div class="ts-mb-4">
      <ts-button outline color="info" @click.prevent="onCreate">
        {{ $t('add_new') }}
      </ts-button>
    </div>
    <ts-table-filter :columns="milestoneColumns" :data="milestones">
      <template slot-scope="{ row }" slot="name">
        <div @click.prevent="onView(row)" class="ts-text-blue-400 ts-cursor-pointer">
          {{ row.milestone_name }}
        </div>
      </template>
      <template slot-scope="{ row }" slot="estimated_start_date">
        {{ row.estimated_start_date }}
      </template>
      <template slot-scope="{ row }" slot="estimated_end_date">
        {{ row.estimated_end_date }}
      </template>
      <template slot-scope="{ row }" slot="owner_name_en">
        {{ row.owner_name_en }}
      </template>
      <template slot-scope="{ row }" slot="project_status">
        {{ row.project_status }}
      </template>
      <template slot-scope="{ row }" slot="created_at">
        {{ row.created_at }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <div class="ts-flex ts-space-x-2">
          <a href="#" class="text-info" @click.prevent="onView(row)" v-tooltip="$t('view')">
            <Icon type="md-eye" size="20" />
          </a>
          <a href="#" class="text-primary" @click.prevent="onEdit(row)" v-tooltip="$t('edit')">
            <Icon type="ios-create" size="20" />
          </a>
          <a href="#" class="text-danger" v-tooltip="$t('delete')" @click="deleteRecord(row)" :disabled="row._deleting">
            <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
            <Icon type="ios-trash" size="20" v-else />
          </a>
        </div>
      </template>
    </ts-table-filter>
    <IviewModal v-model="isCreateMileStone" title="Create Milestone">
      <CreateMileStone v-if="isCreateMileStone" :projectId="projectId" @close="onClose" @fetchData="onFetchData" />
    </IviewModal>
    <IviewModal v-model="isUpdateMileStone" title="Update Milestone">
      <UpdateMileStone v-if="isUpdateMileStone" @close="onClose" @fetchData="onFetchData" :edit_data="edit_data" />
    </IviewModal>
  </div>
</template>

<script>
import IviewModal from '../../components/i-modal-wrapper.vue'
import { mapActions } from 'vuex'
import CreateMileStone from './create-milestone.vue'
import UpdateMileStone from './update-milestone.vue'
export default {
  props: ['milestones'],
  components: {
    CreateMileStone,
    UpdateMileStone,
    IviewModal
  },
  data() {
    return {
      edit_data: undefined,
      isCreateMileStone: false,
      isUpdateMileStone: false,
      projectId: undefined
    }
  },
  computed: {
    milestoneColumns() {
      return [
        {
          title: 'Name',
          slot: 'name',
          minWidth: 80
        },
        {
          title: 'Estemate Start Date',
          slot: 'estimated_start_date',
          minWidth: 80
        },
        {
          title: 'Estemate End Date',
          slot: 'estimated_end_date',
          minWidth: 80
        },
        {
          title: 'Owner Name',
          slot: 'owner_name_en',
          minWidth: 80
        },
        {
          title: 'Status',
          slot: 'project_status',
          minWidth: 80
        },
        {
          title: 'Created At',
          slot: 'created_at',
          minWidth: 80
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['destroy']),
    onCreate() {
      this.isCreateMileStone = true
      this.projectId = this.$route.params.id ? this.$route.params.id : undefined
    },
    onClose() {
      this.edit_data = undefined
      this.isCreateMileStone = false
      this.isUpdateMileStone = false
    },
    onFetchData() {
      this.$emit('fetchMileStone')
    },
    onEdit(data) {
      this.edit_data = data
      this.isCreateMileStone = false
      this.isUpdateMileStone = true
    },
    deleteRecord(record) {
      record._deleting = true
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.milestone_id)
            .then(response => {
              this.$toasted.success(response.message)
              this.$emit('fetchData')
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
            .finally(() => {
              record._deleting = false
            })
        },
        onCancel() { }
      })
    },
    onView(record) {
      this.$router.push({
        name: 'project-milestone-view',
        params: {
          project_id: record.project_id,
          milestone_id: record.milestone_id
        }
      })
    }
  }
}
</script>
